import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface CreateLegacyCredentialsPayload {
  publicKey: string;
  secretKey: string;
  studioId: string;
  force?: boolean;
}

export interface StripeAccountMismatchError {
  code: 'account_mismatch';
  message: string;
  outcome: 'mismatch' | 'unverified';
  connectAccountId?: string;
  legacyAccountId?: string;
}

const createLegacyStripeCredentials = async (
  payload: CreateLegacyCredentialsPayload,
): Promise<unknown> => {
  const response = await baseAPI.post<unknown>(
    '/payment-processor/create',
    payload,
  );
  return response.data;
};

export const useCreateLegacyStripeCredentialsMutation = () => {
  return useMutation({
    mutationFn: createLegacyStripeCredentials,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STRIPE, KEYS.CREDENTIALS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STRIPE_CREDENTIAL_ENVIRONMENT],
      });
      toast.success('Stripe API keys saved');
    },
  });
};
